module.exports = __webpack_public_path__ + "img/question.6564a294.png";